import axios from "axios";

export default async function getFilters(projectName, formName){
    const res = await axios.get(`/project/${projectName}/${formName}/query-add-form`);
    return res.data;
}